(function() {
  /*$('.gb-main-image-with-text-slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   autoplay: true,
   autoplaySpeed: 3000, 
   infinite: false, 
  });*/
  var $slider = $('.gb-main-image-with-text-slider');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    if (nextSlide == 0) {
       var calc =  100 / (slick.slideCount);
      //alert(calc);
    } else {  
       var calc = 100 / (slick.slideCount) * (nextSlide + 1) ;
      // alert(calc);
    }

    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   autoplay: true,
   autoplaySpeed: 3000, 
   infinite: true, 
    dots:true, 
  });  



$(".rq-product-slider-new").slick({
    //autoplay:true,
    slidesToShow:1,
    slidesToScroll:1,
    dots:false,
    draggable:true, 
    adaptiveHeight: true,
    //fade:true,
     //asNavFor: '.rq-thumbnail-slider',
    //prevArrow: false,
    //nextArrow: false,
    
    infinite:true,
    
    prevArrow:'<button class="rq-PrevArrow"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122" xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="40.4" y="41.4" class="st0" width="43.2" height="40.3"/><path d="M95.8,61.2c0-19.2-15.7-34.8-35.1-34.8c-19.4,0-35.1,15.6-35.1,34.8c0,19.2,15.7,34.8,35.1,34.8	C80.1,95.9,95.8,80.4,95.8,61.2z M53.7,61.2l11.6-11.4l1.7,1.7l-9.8,9.7L67,71.3L65.2,73L53.7,61.2z"/></svg></button>',
    nextArrow:'<button class="rq-NextArrow"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122"  xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="39.4" y="40.8" class="st0" width="43.2" height="40.3"/><path d="M27.2,60.8c0,19.2,15.7,34.8,35.1,34.8c19.4,0,35.1-15.6,35.1-34.8c0-19.2-15.7-34.8-35.1-34.8 C42.9,26.1,27.2,41.6,27.2,60.8z M69.3,60.8L57.8,72.3L56,70.5l9.8-9.7L56,50.7l1.8-1.7L69.3,60.8z"/></svg></button>', 
    responsive: [
    {
      breakpoint: 768, 
      settings: {
        dots: true 
      }
    }
  ]
    //nextArrow: $('.gb-main-product-arrows .carousel-next'), 
    //prevArrow:  $('.gb-main-product-arrows .carousel-prev'),
    //responsive: [
    //{
    //  breakpoint: 767,
    //  settings: {
    //  slidesToShow:2,
    //  }
   // }
   //]
 });
  //$('.gb-main-product-arrows .carousel-prev').click(function(){ 
	//	$(this).parent().parent().find('.carousel-gb').slick('slickPrev');
  //});
	
  //$('.gb-main-product-arrows .carousel-next').click(function(e){
		//e.preventDefault(); 
		//$(this).parent().parent().find('.carousel-gb').slick('slickNext');
  //});
    
  //  $('.rq-thumbnail-slider').slick({
  //   slidesToShow: 6,
  //   slidesToScroll: 6,
  //   dots: false,
  //   arrows: true, 
  //   adaptiveHeight: true, 
  //   infinite:false, 
     
  //   prevArrow: '<button class="rq-PrevArrow-thumb"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="75" height="75" viewBox="0 0 75 75" xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="23.8" y="23.2" class="st0" width="26.6" height="27.8"/><path d="M58.4,37.6c0-11.8-9.6-21.4-21.4-21.4s-21.4,9.6-21.4,21.4S25.2,59,37,59S58.4,49.4,58.4,37.6L58.4,37.6z M32.7,37.6l7.1-7	l1.1,1.1l-6,6l6,6.2l-1.1,1L32.7,37.6z"/></svg></button>',
  //   nextArrow: '<button class="rq-NextArrow-thumb"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="75" height="75" viewBox="0 0 75 75"><style type="text/css">	.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="24.8" y="23.1" class="st0" width="27" height="28.9"/><path d="M16.6,37.4c0,11.8,9.6,21.4,21.4,21.4s21.4-9.6,21.4-21.4S49.8,16,38,16S16.6,25.6,16.6,37.4z M42.3,37.4l-7.1,7l-1.1-1.1	l6-6l-6-6.2l1.1-1L42.3,37.4z"/></svg></button>',
  // });
    
  // const $thumbSlider = $('.rq-thumbnail-slider');

  // $thumbSlider.each(function(){
  //   const $slider = $(this);
  //   const slideCount = $slider.find('.thumb').length;
    
  //   // if fewer than 6 slides, show only that many and disable scroll
  //   const slidesToShow = slideCount < 6 ? slideCount : 6;
  //   const slidesToScroll = slideCount < 6 ? slideCount : 6;

  //   $slider.slick({
  //     slidesToShow: slidesToShow,
  //     slidesToScroll: slidesToScroll,
  //     infinite: false,
  //     arrows: slideCount > 1,  // hide arrows if only 1 slide
  //     dots: false,
  //     adaptiveHeight: false,
  //     variableWidth: false,
  //     centerMode: false,
  //     swipeToSlide: true,
  //     prevArrow: '<button class="rq-PrevArrow-thumb"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
  //     nextArrow: '<button class="rq-NextArrow-thumb"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
  //     responsive: [
  //       { breakpoint: 1024, settings: { slidesToShow: Math.min(slideCount, 5) } },
  //       { breakpoint: 768,  settings: { slidesToShow: Math.min(slideCount, 4) } },
  //       { breakpoint: 480,  settings: { slidesToShow: Math.min(slideCount, 3) } }
  //     ]
  //   });
  // });

  const $thumbSlider = $('.rq-thumbnail-slider');

  $thumbSlider.each(function(){
    const $slider = $(this);
    const slideCount = $slider.find('.thumb').length;

    // ✅ Always use fixed width (your CSS controls size)
    // But still fix the small shrink issue by limiting min slidesToShow
    const slidesToShow = slideCount < 6 ? slideCount : 6;

    $slider.slick({
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      infinite: false,
      arrows: slideCount > 1,
      dots: false,
      adaptiveHeight: false,
      variableWidth: true, // ✅ let CSS (97px) define width
      centerMode: false,
      swipeToSlide: true,
      prevArrow: '<button class="rq-PrevArrow-thumb slick-arrow" aria-disabled="false" style="display: block;"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="75" height="75" viewBox="0 0 75 75" xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="23.8" y="23.2" class="st0" width="26.6" height="27.8"></rect><path d="M58.4,37.6c0-11.8-9.6-21.4-21.4-21.4s-21.4,9.6-21.4,21.4S25.2,59,37,59S58.4,49.4,58.4,37.6L58.4,37.6z M32.7,37.6l7.1-7	l1.1,1.1l-6,6l6,6.2l-1.1,1L32.7,37.6z"></path></svg></button>',
      nextArrow: '<button class="rq-NextArrow-thumb slick-arrow" style="" aria-disabled="false"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="75" height="75" viewBox="0 0 75 75"><style type="text/css">	.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="24.8" y="23.1" class="st0" width="27" height="28.9"></rect><path d="M16.6,37.4c0,11.8,9.6,21.4,21.4,21.4s21.4-9.6,21.4-21.4S49.8,16,38,16S16.6,25.6,16.6,37.4z M42.3,37.4l-7.1,7l-1.1-1.1	l6-6l-6-6.2l1.1-1L42.3,37.4z"></path></svg></button>',
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: Math.min(slideCount, 5), variableWidth: true } },
        { breakpoint: 768,  settings: { slidesToShow: Math.min(slideCount, 4), variableWidth: true } },
        { breakpoint: 480,  settings: { slidesToShow: Math.min(slideCount, 3), variableWidth: true } }
      ]
    });
  });
  
  $('.rq-thumbnail-slider a.thumb.slick-slide').click(function(e) {
   e.preventDefault();
    var slideno = $(this).attr('data-slick-index');
    $('.rq-product-slider-new').slick('slickGoTo', slideno);
  });

   jQuery(document).on('click', ".gb-product-compare", function(){

        jQuery.cookie("testCookie", "gb");
      

   // alert(jQuery.cookie("testCookie"));
   });
  // alert(jQuery.cookie("testCookie"));

/* $( "header-menu" ).hover(
      function() {
        $(this).find("details").attr("open" , "rem");
        $(this).find('summary').attr("aria-expanded", 'true');
      }, function() {
        $( this ).find("details").removeAttr("open");
        $( this ).find('summary').attr("aria-expanded", 'false');
      }
    );
     */
    $("header-menu details").mouseover(function(){
        $("header-menu details").removeAttr("open");
        $("header-menu details").find('summary').attr("aria-expanded", 'true');
        $(this).attr("open" , "rem");
        $(this).find('summary').attr("aria-expanded", 'true');
    });
    $("header").mouseleave(function(){
        $( this ).find("details").removeAttr("open");
        $( this ).find('summary').attr("aria-expanded", 'false');
    });

    $('.gb-collection-list-main-pad .collection').addClass('loading');
     $('.template-search__results .collection').addClass('loading');
  setTimeout(function () {  
    $('.product-grid').each(function(){  
      var highestBox = 0;
      $('.card__heading', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.card__heading',this).height(highestBox);
    }); 
    $('.gb-collection-list-main-pad .collection').removeClass('loading');
    $('.template-search__results .collection').removeClass('loading');
  }, 3000); 
  
/*jQuery(document).on('click', ".facets__item label", function(){
   setTimeout(function () {
    $('.product-grid').each(function(){  
      var highestBox = 0;
      $('.card__heading', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.card__heading',this).height(highestBox);
    });   
    $('.gb-collection-list-main-pad .collection').removeClass('loading');
    $('.template-search__results .collection').removeClass('loading');  
   }, 3000);   
});   
jQuery(document).on('click', "a.active-facets__button-remove", function(){
   setTimeout(function () {
    $('.product-grid').each(function(){  
      var highestBox = 0;
      $('.card__heading', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.card__heading',this).height(highestBox);
    }); 
   $('.gb-collection-list-main-pad .collection').removeClass('loading');
    $('.template-search__results .collection').removeClass('loading');
   }, 3000);   
});    
jQuery(document).on('click', "span.active-facets__button-inner", function(){
   setTimeout(function () {
    $('.product-grid').each(function(){  
      var highestBox = 0;
      $('.card__heading', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.card__heading',this).height(highestBox);
    }); 
    $('.gb-collection-list-main-pad .collection').removeClass('loading');
    $('.template-search__results .collection').removeClass('loading');
   }, 3000);   
});  
jQuery(document).on('change', "select#SortBy", function(){
   setTimeout(function () {
    $('.product-grid').each(function(){  
      var highestBox = 0;
      $('.card__heading', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.card__heading',this).height(highestBox);
    }); 
    $('.gb-collection-list-main-pad .collection').removeClass('loading');
    $('.template-search__results .collection').removeClass('loading');
   }, 3000);   
});   
  */
jQuery(document).on('click', "a.active-facets__button-remove", function(){
   setTimeout(function () {
    $('.product-grid').each(function(){  
      var highestBox = 0;
      $('.card__heading', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.card__heading',this).height(highestBox);
    }); 
  // $('.gb-collection-list-main-pad .collection').removeClass('loading');
   // $('.template-search__results .collection').removeClass('loading');
   }, 3000);   
});    


  
// scroll bottom to top start //
      $(document).ready(function(){
      	"use strict";
        var offSetTop = 100;
        var $scrollToTopButton = $('.gb-top-bottom-btn');
      	//Check to see if the window is top if not then display button
      	$(window).scroll(function(){
      		if ($(this).scrollTop() > offSetTop) {
      			$scrollToTopButton.fadeIn();
      		} else {
      			$scrollToTopButton.fadeOut();
      		}
      	});
      	
      	//Click event to scroll to top
      	$scrollToTopButton.click(function(){
      		$('html, body').animate({scrollTop : 0},800);
      		return false;
      	});
      	
      });
 //  scroll bottom to top end //


})();
